module.exports = require("./ig.d.ts");